import React from 'react';
function ManualEmailValidation (props) {
    return (
        <div className="overlay-message centered" id="message-manual-validation">
            <div className="overlay-message-wrapper">
                <div className="main-icon email-icon">
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.47 48">
                        <title>email-white</title>
                        <path className="cls-1" d="M78.73,5V43H5.27V5H78.73m2-5H3.27a3,3,0,0,0-3,3V45a3,3,0,0,0,3,3H80.73a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z" transform="translate(-0.27)"></path>
                        <polyline className="cls-2" points="3.48 44.19 35.71 24.46 41.73 28 41.73 28 46.94 23.98 79.99 44.19"></polyline>
                        <polyline className="cls-3" points="3.48 3.58 41.71 26.99 41.71 26.99 79.99 3.58"></polyline>
                    </svg>
                </div>
                <h5 className="splunk-h5 overlay-title-padding">Please Validate Your Email Address</h5>
                <p className="splunk-body">An email with a link to verify your email address has been sent to your inbox. When you click on the link, you’ll be prompted to log in and will be on your way in no time.</p>
            </div>
        </div>
    )
}
export default ManualEmailValidation;